module.exports = __webpack_public_path__ + "img/waitingbg.c6a7137a.gif";